import Withdraw6 from "./components/Withdraw6";
import Withdraw1 from "./components/Withdraw1";
import Withdraw2 from "./components/Withdraw2";
import Withdraw3 from "./components/Withdraw3";
import Withdraw4 from "./components/Withdraw4";
import Withdraw5 from "./components/Withdraw5";
import { Wrapper } from "./style";
const Withdraw = ({ t }) => {
  return (
    <Wrapper>
      <Withdraw1 t={t} />
      <Withdraw2 t={t} />
      <Withdraw3 t={t} />
      <Withdraw4 t={t} />
      <Withdraw5 t={t} />
      <Withdraw6 t={t} />
    </Wrapper>
  );
};

export default Withdraw;
